import { AppHelper } from "../appHelper.js"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp.js";
import { Helper } from "../core/util/helper.js";
import { Commands } from "../core/util/commandManager.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { General } from "../../siteManagement/general.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { Config } from "../core/config/config.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { GeocodeStatus } from "../geomap/components/geocode/geocodeStatus.js";
import Skills from "../core/components/skills.js";
import OpeningHoursInGrid, { AddressOpeningHours } from "./openingHoursInGrid.js";
import { openStateDialog } from "./stateDialog.js";
import { TreeNodeVm } from "../generalSettings/skills/skillsInterfaces.js";
import { PageTitleProps } from "../core/components/pageTitle.js";
import React from "react";
export default class AddressApp extends React.Component<AddressAppProps, any> {
    private lockId: number;
    common = new AppHelper();
    deleteEnabled = false;
    isDeleted = false;
    currentUrl: string = null;
    translations: {};
    contactsGridOptions: {};
    allocationsGridOptions: {};
    openingHoursInGridOptions: {};
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    geocode: GeocodeStatus = null;
    openingHoursInGridRef: OpeningHoursInGrid;


    constructor(props: AddressAppProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);

        this.refreshDeleteEnabled();
        this.props.dataSources["preislisteDataSource"] = [];
        this.doOnVskChanged(this.props.entity.Vsk);
        this.props.dataSources["reisepknDataSource"] = [];
        this.getReisepkn();
        this.props.context.contactsGrid = this.contactsGridOptions;
        this.props.context.allocationsGrid = this.allocationsGridOptions;
        this.props.context.openingHoursInGrid = this.openingHoursInGridOptions;

        if (this.props.entity.RecordRight.CanWrite) {
            this.common.unloadHelper.addBeforeUnloadCallback(() => {
                this.releaseLock();
            });
        }

        General.Sheet.Manager.getTopMostSheet().bind(SheetEventType.Custom, (data) => {
            if (data.cmd == "addressChanged") {
                this.common.setEntityDirtyState(true);
            }

        })
    }

    private getPreisliste(liste: string) {
        HTTPService.get('InvoiceLookup/GetPlistensWithTab/?liste=' + encodeURIComponent(liste))
            .then((result) => {
                Helper.setArrayValues(this.props.dataSources["preislisteDataSource"], result);
                this.common.commandManager.runCommand("entity.Preisliste", Commands.RELOADDATASOURCE);
            });
    }

    private getReisepkn() {
        HTTPService.get('NachschlagLookup/GetViewByTabId?id=17')
            .then((result) => {
                if (Array.isArray(result)) {
                    for (let i = 0; i < result.length; i++) {
                        result[i].Key = result[i].Key.toString();
                    }
                }
                Helper.setArrayValues(this.props.dataSources["reisepknDataSource"], result);
                this.common.commandManager.runCommand("entity.Reisepkn", Commands.RELOADDATASOURCE);
            });
    }

    private doOnVskChanged(value) {
        if (value == "2")
            this.getPreisliste("SPLISTE1");
        else
            this.getPreisliste("PLISTE");
        //Innosoft.Core.Utils.MetaDataHelper.setFieldValue(this.props.entity, "entity.Preisliste", null);

    }
    private refreshDeleteEnabled() {
        this.deleteEnabled = !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite
    }
    remove = () => {
        DialogHelper.confirm(Config.translations.deleteMessage).then(isOK => {
            if (isOK) {
                HTTPService.post<JsonResultClass>('Address/Delete?adrnr=' + encodeURIComponent(this.props.entity.AdrNr))
                    .then(result => {
                        if (result.Code === 0) {
                            NotificationHelper.showSuccessMessage(result.Message);
                            if (this.common.isWindow) {
                                this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                                this.common.sheetWrapper.hide();
                            } else {
                                this.deleteEnabled = false;
                                this.isDeleted = true;
                                this.props.entity.RecordRight.CanWrite = false;
                                this.setState({});
                                setTimeout(() => {
                                    window.location.href = Config.baseUrl + "DynamicSearch/Address";
                                }, 1000);
                            }
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }
    releaseLock = () => {
        if (this.lockId != undefined) {
            clearInterval(this.lockId);
            Helper.releaseLock(this.props.entity.IsId, "VKUNADR");
            this.lockId = undefined;
        }
    }

    handleFieldChange = async (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Projnr":
                break;
            case "entity.Vsk":
                this.doOnVskChanged(value);
                break;
            case "entity.CountryId":
                this.handleFieldChange({ model: "entity.StateId" }, null, null);
                if (Helper.hasValue(dataItem) && !Helper.isNullOrEmpty(dataItem.FallbackExpense)) {
                    if (this.props.entity.Land != dataItem.FallbackExpense) {
                        NotificationHelper.showInfoMessage(Helper.getTranslation("WebSMS.Country.Override"));
                    }
                    this.handleFieldChange({ model: "entity.Land" }, dataItem.FallbackExpense, null);
                }
                break;
            case "entity.StateId":
                if (dataItem) {
                    const { updateKalenderId, updateTimezone } = await openStateDialog({
                        state: dataItem,
                        updateKalenderId: dataItem.KalenderId != this.props.entity.Kalenderid,
                        updateTimezone: dataItem.Timezone != this.props.entity.TimeZone
                    })
                    if (updateKalenderId && Helper.hasValue(dataItem.KalenderId)) {
                        this.handleFieldChange({ model: "entity.Kalenderid" }, dataItem.KalenderId, null)
                    }
                    if (updateTimezone && !Helper.isNullOrEmpty(dataItem.Timezone)) {
                        this.handleFieldChange({ model: "entity.TimeZone" }, dataItem.Timezone, null)
                    }
                }
                break;
            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    save = async (closeAfterSave) => {
        for (const loadedModule of this.common.getLoadedModules()) {
            loadedModule.Save();
        }
        if (this.common.validate()) {

            if (this.props.entity.GeocodeEnabled && !this.props.entity.UseAdrLocation) {
                //update lat long and timezone from new coors
                const resGeodataChanged = await GeocodeStatus.updateGecodeAddress(
                    this.props.entity.AdrNr,
                    this.props.entity.Strasse,
                    this.props.entity.Plz,
                    this.props.entity.Ort,
                    this.props.entity.Land,
                    this.props.entity.Breitegrad,
                    this.props.entity.Laengegrad);

                //update fields and gui
                if (resGeodataChanged.changed) {
                    this.handleFieldChange({ model: "entity.Laengegrad" }, resGeodataChanged.long);
                    this.handleFieldChange({ model: "entity.Breitegrad" }, resGeodataChanged.lat);
                    if (resGeodataChanged.lat == 0 && resGeodataChanged.long == 0)
                        this.handleFieldChange({ model: "entity.GeocodeText" }, "");
                }

                //update timezone
                let currentTimeZone = this.props.entity.TimeZone != null ? this.props.entity.TimeZone : "";
                let changedCoords = (resGeodataChanged.changed && resGeodataChanged.lat != 0 && resGeodataChanged.lat != 0);
                if (changedCoords || currentTimeZone == "") {
                    const timeZone = await GeocodeStatus.updateTimeZone(
                        changedCoords ? resGeodataChanged.lat : this.props.entity.Breitegrad,
                        changedCoords ? resGeodataChanged.long : this.props.entity.Laengegrad);
                    if (Helper.hasValue(timeZone) && timeZone != currentTimeZone) {
                        this.handleFieldChange({ model: "entity.TimeZone" }, timeZone);
                        NotificationHelper.showSuccessMessage(Helper.getTranslation("WebSMS.Geodata.TimeZoneUpdated"));
                    }
                }
            }

            if (Helper.hasValue(this.openingHoursInGridRef))
                this.props.entity.OpeningHours = this.openingHoursInGridRef.getEntries();
            const result = await HTTPService.post("Address/Save", this.props.entity)
            if (result.Code === 0) {
                if (this.props.entity.IsNew /*&& !this.common.isWindow*/) {
                    const data = this.common.sheetWrapper.getExternalData();
                    if (!data || data.preventUrlChangeOnNew !== true) {
                        General.Functions.HistoryState.replaceState("Address/Edit?id=" + encodeURIComponent(this.props.entity.AdrNr));
                    }
                }
                if (Helper.hasValue(result.Data.IsId) && this.lockId == undefined) {
                    this.lockId = Helper.keepLockAlive("Lock.ashx", result.Data.IsId, "VKUNADR", 10000);
                }
                let indivData = result.Data.IndividualFields
                Helper.updateEntity(this.props.entity, result.Data);
                for (var key in indivData) {
                    this.props.entity.IndividualFields[key] = indivData[key];
                }

                this.props.entity.IsNew = false;
                this.refreshDeleteEnabled();
                $(window).trigger("saveSkills", this.props.entity);
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, closeAfterSave);
        }
    }

    onGeocodeChange = (long: number, lat: number) => {
        this.handleFieldChange({ model: "entity.Laengegrad" }, long);
        this.handleFieldChange({ model: "entity.Breitegrad" }, lat);
        if (lat == 0 && long == 0)
            this.handleFieldChange({ model: "entity.GeocodeText" }, "");
    }

    renderGeocodeStatus = () => {
        return (
            <GeocodeStatus ref={(r) => { this.geocode = r }}
                commandManager={this.common.commandManager}
                GeocodeEnabled={this.props.entity.GeocodeEnabled}
                Laengegrad={this.props.entity.Laengegrad}
                Breitegrad={this.props.entity.Breitegrad}
                GeocodeText={this.props.entity.GeocodeText}
                GeocodeMatch={this.props.entity.GeocodeMatch}
                GeocodeDisplayName={this.props.entity.GeocodeDisplayName}
                onGeocodeDataChange={this.onGeocodeChange}
                readOnly={!this.props.entity.RecordRight.CanWrite}
                manualLocation={this.props.entity.UseAdrLocation === true} />
        );
    }

    componentDidMount() {
        if (this.props.entity.RecordRight.CanWrite && Helper.hasValue(this.props.entity.IsId) && !this.props.entity.IsNew) {
            this.lockId = Helper.keepLockAlive("Lock.ashx", this.props.entity.IsId, "VKUNADR", 10000);
        }
    }

    private onTreeDataChanged = (treeData: TreeNodeVm[]) => {
        this.common.setEntityDirtyState(true);
    }

    createSkills = () => {
        let entity: any = this.props.entity;
        return <Skills entity={entity} runningContext="address" onTreeDataChanged={this.onTreeDataChanged}
            title={Helper.getTranslation["WebSMS.Skills.Skills"]} editable={true} />;
    }

    renderOpeningHoursInGrid = (defaultFieldProps: any) => {
        return <OpeningHoursInGrid {...this.props} ref={(ref) => this.openingHoursInGridRef = ref} helpUrl={defaultFieldProps.helpUrl}  />;
    }

    openCockpit = () => {
        General.Sheet.Manager.createSheetWithUrl(`Cockpit/IndexAddress?id=${encodeURIComponent(this.props.entity.AdrNr)}`, null, null, false);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        const titleProps: PageTitleProps = {
            title: this.props.title,
            value: this.props.entity.AdrNr,
            locked: Helper.hasValue(this.props.entity.LockMessage) && this.props.entity.LockMessage.trim() !== "",
            lockInfo: this.props.entity.LockMessage
        };
        return <CommonApp {...props} titleProps={titleProps} />;
    }
};

export interface AddressAppProps extends AppBaseProps {
    entity: EntityAddress;
    context: AddressAppPropsContext;
}

interface AddressAppPropsContext extends Context {
    contactsGrid?: {};
    allocationsGrid?: {};
    openingHoursInGrid?: {};
}

export interface EntityAddress extends Entity {
    AdrNr: string;
    Vsk: string;
    IsId?: number;
    LockMessage?: string;
    ContactRights?: {
        CanRead: boolean;
        CanWrite: boolean;
    }
    GeocodeEnabled: boolean;
    Laengegrad: number;
    Breitegrad: number;
    GeocodeText: string;
    GeocodeMatch: string;
    Strasse: string;
    Plz: string;
    Ort: string;
    Land: string;
    UseAdrLocation: boolean;
    OpeningHoursLoaded?: boolean;
    OpeningHours?: AddressOpeningHours[];
    TimeZone: string;
    GeocodeDisplayName: string;
    Kalenderid?: number;
}